import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class RegulationsApi extends ApiModule {
	constructor() {
		super(ModulesMap.REGULATIONS, {
			entity: 'regulations',
		})
	}

	regulationHasMetricType(options = {}) {
		const config = {
			url: this.generateUrl(true, {
				suffix: 'has_metric_type',
			}),
			requestOptions: {
				method: 'POST',
			},
		}

		return this.apiRequestWrap(this.moduleName, config, options)
	}

	regulationAddStageAndPlanWorks(options = {}) {
		const config = {
			url: this.generateUrl(true, {
				suffix: 'add_stage_and_plan_works',
			}),
			requestOptions: {
				method: 'POST',
			},
		}

		return this.apiRequestWrap(this.moduleName, config, options)
	}
}